const bytesToMegabytes = (bytes: number) => {
  return bytes / (1024 * 1024);
};

export { bytesToMegabytes };
